<div class="info-page">
	<div class="info-page-container">
		<div class="info-page-header">
			<span class="text-4xl">Datenschutz</span>
		</div>

		<div class="text-block">
			<div class="text-block-header">
			</div>
			<div class="text-block-content">
				<p>Wir freuen uns über Ihr Interesse an unserem Arztportal. Der Schutz Ihrer personenbezogenen Daten ist
					uns ein wichtiges Anliegen. Im Folgenden informieren wir Sie ausführlich über die Erhebung,
					Verarbeitung und Nutzung personenbezogener Daten im Rahmen unserer Website.
				</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				1. Verantwortlicher
			</div>
			<div class="text-block-content">
				<p>Verantwortlich für die Datenverarbeitung im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
				<p>Aliacura e.K.</p>
				<p>Hauptstraße 4</p>
				<p>91443 Scheinfeld</p>
				<p>E-Mail: datenschutz&#64;patriacura.de</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Gesetzlich vorgeschriebener Datenschutzbeauftragter
			</div>
			<div class="text-block-content">
				<p> Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.</p>
				<p>Bernhard Metzger</p>
				<p>Schwarzenbergstr. 20</p>
				<p>91443 Scheinfeld</p>
				<p>E-Mail: bernhard.metzger&#64;patriacura.de</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				2. Allgemeines zur Datenverarbeitung
			</div>
			<div class="text-block-content">
				<p>Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
					Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich
					ist.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Speicherdauer
			</div>
			<div class="text-block-content">
				<p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde,
					verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
					Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung
					widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die
					Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
					Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung
			</div>
			<div class="text-block-content">
				<p>Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten
					auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
					Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen
					Einwilligung in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die
					Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die
					Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr Endgerät (z. B. via
					Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich auf Grundlage
					von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.</p>
				<p>Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich,
					verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten
					wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind, auf
					Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres
					berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall
					einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser Datenschutzerklärung
					informiert. unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen
					Website sowie unserer Inhalte und Leistungen erforderlich ist.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				3. Zugriffsdaten und Hosting
			</div>
			<div class="text-block-content">
				<p>Beim Aufrufen unserer Website werden automatisch Informationen durch den verwendeten Browser an
					unseren Server gesendet (Server-Logfiles). Dies umfasst:</p>
				<li>IP-Adresse</li>
				<li>Datum und Uhrzeit des Zugriffs</li>
				<li>Name und URL der abgerufenen Datei</li>
				<li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
				<li>verwendeter Browser und ggf. das Betriebssystem</li>
				<p>Diese Daten dienen der Sicherstellung eines reibungslosen Verbindungsaufbaus und einer komfortablen
					Nutzung der Website sowie der Systemsicherheit und -stabilität. Die Speicherung erfolgt auf
					Grundlage von Art. 6 Abs. 1 lit. f DSGVO.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				4. Hosting und Content Delivery Networks (CDN)
			</div>
			<div class="text-block-content">
				<p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
				<strong class="pt-2">Hetzner</strong>
				<p>Anbieter ist die Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen (nachfolgend Hetzner).
					Details entnehmen Sie der Datenschutzerklärung von Hetzner:
					https://www.hetzner.com/de/rechtliches/datenschutz.</p>
				<p>Die Verwendung von Hetzner erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein
					berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. Sofern eine
					entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage
					von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von
					Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z.B. Device-Fingerprinting) im
					Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				5. Haftung
			</div>
			<div class="text-block-content">
				<p>Haftung nur bei wesentlichen Vertragspflichten oder gesetzlicher Pflicht. Keine Haftung für
					Behandlungs- oder Medikationsfehler. Diese liegen im Verantwortungsbereich des jeweiligen
					behandelnden Arztes. Keine Haftung für mittelbare Schäden oder höhere Gewalt.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				6. Tracking-Technologien
			</div>
			<div class="text-block-content">
				<p>Beim Aufrufen unserer Website werden automatisch Informationen durch den verwendeten Browser an
					unseren Server gesendet (Server-Logfiles). Dies umfasst:</p>
				<li>IP-Adresse</li>
				<li>Datum und Uhrzeit des Zugriffs</li>
				<li>Name und URL der abgerufenen Datei</li>
				<li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
				<li>verwendeter Browser und ggf. das Betriebssystem</li>
				<p>Diese Daten dienen der Sicherstellung eines reibungslosen Verbindungsaufbaus und einer komfortablen
					Nutzung der Website sowie der Systemsicherheit und -stabilität. Die Speicherung erfolgt auf
					Grundlage von Art. 6 Abs. 1 lit. f DSGVO.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				7. Cookies
			</div>
			<div class="text-block-content">
				<p>Unsere Website verwendet Cookies. Diese dienen der nutzerfreundlichen Gestaltung sowie der
					statistischen Auswertung des Nutzerverhaltens.
					Sie können Ihre Einwilligung zur Nutzung von Cookies jederzeit über die Cookie-Einstellungen
					widerrufen oder ändern.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				8. Kontaktaufnahme
			</div>
			<div class="text-block-content">
				<p>Wenn Sie mit uns Kontakt aufnehmen (z.B. per E-Mail oder Kontaktformular), werden Ihre Angaben zur
					Bearbeitung der Anfrage und deren Abwicklung verarbeitet. Die Verarbeitung erfolgt auf Grundlage von
					Art. 6 Abs. 1 lit. b DSGVO.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				9. Registrierung und Nutzung des Portals
			</div>
			<div class="text-block-content">
				<p>Bei der Registrierung auf unserem Portal erfassen wir folgende personenbezogene Daten:</p>
				<li>Anrede</li>
				<li>Vorname, Nachname</li>
				<li>Geburtsdatum</li>
				<li>E-Mail-Adresse</li>
				<li>Telefonnummer</li>
				<li>Wohnadresse</li>
				<li>Scan des Personalausweises</li>
				<p>Diese Daten sind erforderlich zur eindeutigen Identifikation und zur Durchführung ärztlicher
					Behandlungen. Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b und lit. c DSGVO.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Telesprechstunden
			</div>
			<div class="text-block-content">
				<p>Für die Telesprechstunden werden die von Ihrem Arzt bevorzugten bzw. mit Ihnen vereinbarten
					Kommunikationsmittel verwendet. Dies liegt außerhalb des Angebots dieses Portals und fällt in die
					Verantwortung der behandelnden Ärzte. auf unserem Portal erfassen wir folgende personenbezogene
					Daten bei der Registrierung:</p>
				<li>Anrede</li>
				<li>Vorname, Nachname</li>
				<li>Geburtsdatum</li>
				<li>E-Mail-Adresse</li>
				<li>Telefonnummer</li>
				<li>Wohnadresse</li>
				<li>Scan des Personalausweises</li>
				<p>Zusätzlich alle Daten die Sie uns oder den Ärzten zur Verfügung stellen. Diese Daten sind erforderlich zur eindeutigen Identifikation und zur Durchführung ärztlicher Behandlungen. Bei extern von Ihnen oder vom Arzt für Sie hochgeladenen Dokumenten, werden Sie beim Arztwechsel gefragt, ob Sie diese dem neuen Arzt ebenfalls zur Verfügung stellen möchten. Dies ist auch im Nachhinein über Ihre Patientenakte möglich. Behandlungsnotizen der vorher behandelnden Ärzte und bereits über das Portal ausgestellte Rezepte werden zu Ihrer Sicherheit automatisch an den weiterbehandelnden Arzt übertragen. Sollten Sie dies nicht wünschen, so besprechen Sie dies bitte mit ihrem aktuell behandelnden Arzt, so dass dieser ungewünschte Notizen vor dem Arztwechsel für Sie entfernen kann. Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b und lit. c DSGVO.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				10. Weitergabe von Daten an Dritte
			</div>
			<div class="text-block-content">
				<p>Eine Weitergabe an Dritte erfolgt nur, wenn dies gesetzlich zulässig ist oder Sie eingewilligt haben.
					Externe Dienstleister (z.B. Hosting, Wartung) sind vertraglich zur Einhaltung der DSGVO
					verpflichtet.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Datenübermittlung bei Vertragsschluss für Dienstleistungen und digitale Inhalte
			</div>
			<div class="text-block-content">
				<p>Wir übermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung
					notwendig ist, etwa an das mit der Zahlungsabwicklung beauftragte Kreditinstitut.
					Eine weitergehende Übermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie der Übermittlung
					ausdrücklich zugestimmt haben. Eine Weitergabe Ihrer Daten an Dritte ohne ausdrückliche
					Einwilligung, etwa zu Zwecken der Werbung, erfolgt nicht.
					Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten
					zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Zahlungsdienste
			</div>
			<div class="text-block-content">
				<p>Wir binden Zahlungsdienste von Drittunternehmen auf unserer Website ein. Wenn Sie eine Zahlung
					tätigen, werden Ihre Zahlungsdaten (z. B. Name, Zahlungssumme, Kontoverbindung, Kreditkartennummer)
					vom jeweiligen Zahlungsdienstleister zum Zwecke der Zahlungsabwicklung verarbeitet. Für diese
					Transaktionen gelten die jeweiligen Vertrags- und Datenschutzbestimmungen der Anbieter.
					Der Einsatz der Zahlungsdienstleister erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
					(Vertragsabwicklung) sowie im Interesse eines möglichst reibungslosen, komfortablen und sicheren
					Zahlungsvorgangs (Art. 6 Abs. 1 lit. f DSGVO). Soweit für bestimmte Handlungen Ihre Einwilligung
					abgefragt wird, ist Art. 6 Abs. 1 lit. a DSGVO Rechtsgrundlage der Datenverarbeitung; Einwilligungen
					sind jederzeit für die Zukunft widerrufbar.</p>
				<strong class="pt-2">Folgende Zahlungsdienste / Zahlungsdienstleister setzen wir ein:</strong>
				<strong class="pt-2">PayPal</strong>
				<p>Anbieter dieses Zahlungsdienstes ist PayPal (Europe) S.à.r.l. et Cie, S.C.A., 22-24 Boulevard Royal,
					L-2449 Luxembourg (im Folgenden „PayPal“).
					Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt.
					Details finden Sie hier: https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full.
					Datenschutzerklärung: https://www.paypal.com/de/webapps/mpp/ua/privacy-full</p>
				<strong class="pt-2">Deutsche Banken (z.B. SEPA-Überweisung)</strong>
				<p>Für Überweisungen per SEPA-Verfahren erfolgt die Verarbeitung personenbezogener Daten durch die
					jeweils beteiligten Banken gemäß deren eigenen Datenschutzbestimmungen. In diesem Rahmen übermitteln
					wir notwendige Informationen wie Ihren Namen, IBAN, BIC und Zahlungsbetrag an das ausführende
					Kreditinstitut.
					Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b DSGVO. an Dritte erfolgt nur, wenn dies
					gesetzlich zulässig ist oder Sie eingewilligt haben. Externe Dienstleister (z.B. Hosting, Wartung)
					sind vertraglich zur Einhaltung der DSGVO verpflichtet.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				11. Analyse-Tools und Werbung
			</div>
			<div class="text-block-content">
				<p>Wir verwenden keine Analyse- oder Tracking-Tools wie Google Analytics oder Facebook Pixel.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				12. Newsletter
			</div>
			<div class="text-block-content">
				<p>Ein Newsletter wird derzeit nicht angeboten.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				13. Rechte der betroffenen Personen
			</div>
			<div class="text-block-content">
				<p>Sie haben das Recht auf:</p>
				<li>Auskunft gemäß Art. 15 DSGVO</li>
				<li>Berichtigung gemäß Art. 16 DSGVO</li>
				<li>Löschung gemäß Art. 17 DSGVO</li>
				<li>Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
				<li>Widerspruch gegen die Verarbeitung gemäß Art. 21 DSGVO</li>
				<li>Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
				<p>Zur Ausübung Ihrer Rechte wenden Sie sich bitte an datenschutz&#64;patriacura.de.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				14. Datensicherheit
			</div>
			<div class="text-block-content">
				<p>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust oder unberechtigten Zugriff zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				15. Änderungen dieser Datenschutzerklärung
			</div>
			<div class="text-block-content">
				<p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen. Die aktuelle Version ist stets auf unserer Website verfügbar.</p>
				<strong class="pt-6">Stand: April 2025</strong>
			</div>
		</div>
	</div>
</div>
